import { render, staticRenderFns } from "./FormerYearTreeOchart.vue?vue&type=template&id=346eb35d&scoped=true"
import script from "./FormerYearTreeOchart.vue?vue&type=script&lang=js"
export * from "./FormerYearTreeOchart.vue?vue&type=script&lang=js"
import style0 from "../../statistics/css/companyOchart.css?vue&type=style&index=0&id=346eb35d&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346eb35d",
  null
  
)

export default component.exports